import { render } from "./app-button-copy.vue?vue&type=template&id=f7f341d4"
import script from "./app-button-copy.vue?vue&type=script&lang=js"
export * from "./app-button-copy.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/button/app-button-copy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f7f341d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f7f341d4', __exports__)) {
    console.log('reload')
    api.reload('f7f341d4', __exports__)
  }
  
  module.hot.accept("./app-button-copy.vue?vue&type=template&id=f7f341d4", () => {
    console.log('re-render')
    api.rerender('f7f341d4', render)
  })

}


export default __exports__